require("datejs/src/core/i18n.js");
require("datejs/src/core/core.js");
require("datejs/src/core/core-prototypes.js");
require("datejs/src/core/sugarpak.js");
require("datejs/src/core/format_parser.js");
require("datejs/src/core/parsing_operators.js");
require("datejs/src/core/parsing_translator.js");
require("datejs/src/core/parsing_grammar.js");
require("datejs/src/core/parser.js");

require("../lib/jquery-ui-1.12.1.custom.js");
require("../lib/jquery.timeago.js");
require("../lib/debug.js");



//////////////////
// WEBPACK FOOTER
// ./app/src/libs.js
// module id = FbJA
// module chunks = 4